interface RequestOptions {
  method?: "GET" | "HEAD" | "POST" | "PUT" | "DELETE" | "CONNECT" | "OPTIONS" | "TRACE" | "PATCH"
  language?: string
  body?: any
  headers?: HeadersInit
  token?: string
  session?: string | null
}

const defaultHeaders: HeadersInit = {
  Accept: "application/json",
  "Content-Type": "application/json",
  "Accept-Encoding": "gzip",
  "X-Happy-Cart-Channel": import.meta.env.PUBLIC_HAPPY_CART_CHANNEL,
}

const defaultOptions: RequestOptions = {
  method: "GET",
  headers: {},
  language: "de",
  session: null,
}

const apiRequest = async (path: string, options: RequestOptions = {}): Promise<any> => {
  const { method, headers, language, body, token } = { ...defaultOptions, ...options }
  const result = await fetch(
    `${import.meta.env.PUBLIC_CMS_API_URL}${path}${path.includes("?") ? "&" : "?"}language=${language}`,
    {
      method,
      // Make the request send session cookies
      credentials: "include",
      headers: {
        ...(options.session ? { "x-happy-cart-session-id": options.session } : {}),
        ...defaultHeaders,
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
        ...headers,
      },
      body: body ? JSON.stringify(body) : undefined,
    }
  )
  if (result.ok) {
    let json
    try {
      json = await result.json()
    } catch (error) {
      throw JSON.stringify({
        status: result.status,
        message: result.body,
        error: "Error parsing JSON",
        errorMessage: error,
        success: false,
      })
    }
    if (json.error) {
      throw JSON.stringify({
        status: result.status,
        message: result.statusText,
        error: json.error,
        success: false,
      })
    }
    return json
  } else {
    const json = await result.json()
    throw {
      status: result.status,
      message: json.message,
      errors: json.errors,
      success: false,
    }
  }
}

export default apiRequest
